const initialState = {
    command: null, // Stores the matched command
};

const commandReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_COMMAND":
            return { ...state, command: action.payload }; // Update the matched command
        case "RESET_COMMAND":
            return { ...state, command: null }; // Reset command
        default:
            return state;
    }
};

export default commandReducer;
